import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Index from '@/pages/index'
import Login from '@/pages/login'
import Register from '@/pages/register'
import GoodsList from '@/pages/goodsList'
import Goodsdetail from '@/pages/goodsdetail'
import Jiesuan from '@/pages/jiesuan'
import test from '@/pages/test'
import Usercenter from '@/pages/usercenter'
import Zhuanqu from '@/pages/zhuanqu'
import Jieguo from '@/pages/jieguo'
import Cart from '@/pages/cart'
import Seckill from '@/pages/seckill'
import Newslist from '@/pages/newslist'
import Page from '@/pages/page'
import Add_pinjia from '@/pages/add_pinjia'
import Jifengoods_detail from '@/pages/jifengoods_detail'
import Newschd from '@/pages/newschd'
import Findpwd from '@/pages/findpwd'
import ReturnMoney from '@/pages/returnMoney'
Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    }, {
      path: '/login',
      name: 'login',
      component: Login
    }, {
      path: '/goodsList',
      name: 'goodsList',
      component: GoodsList
    }, {
      path: '/register',
      name: 'register',
      component: Register
    }, {
      path: '/Newschd',
      name: 'Newschd',
      component: Newschd
    }, {
      path: '/findpwd',
      name: 'findpwd',
      component: Findpwd
    }, {
      path: '/goodsdetail',
      name: 'goodsdetail',
      component: Goodsdetail
    }, {
      path: '/jifengoods_detail',
      name: 'jifengoods_detail',
      component: Jifengoods_detail
    }, {
      path: '/jiesuan',
      name: 'jiesuan',
      component: Jiesuan
    }, {
      path: '/usercenter',
      name: 'usercenter',
      component: Usercenter
    }, {
      path: '/jieguo',
      name: 'jieguo',
      component: Jieguo
    }, {
      path: '/zhuanqu',
      name: 'zhuanqu',
      component: Zhuanqu
    }, {
      path: '/cart',
      name: 'cart',
      component: Cart
    }, {
      path: '/seckill',
      name: 'seckill',
      component: Seckill
    }, {
      path: '/newslist',
      name: 'newslist',
      component: Newslist
    }, {
      path: '/newschd',
      name: 'newschd',
      component: Newschd
    }, {
      path: '/page',
      name: 'page',
      component: Page
    }, {
      path: '/add_pinjia',
      name: 'add_pinjia',
      component: Add_pinjia
    }, {
      path: '/test',
      name: 'test',
      component: test
    }, {
      path: '/returnMoney',
      name: 'returnMoney',
      component: ReturnMoney
    }
  ],


})



// WEBPACK FOOTER //
// ./src/router/index.js